// REDESIGN 2024

// import * as Sentry from '@sentry/browser';
import { isMobile } from './../../utils/viewport';
import { navigationElement } from './../navigationElements';
import Sentry from '@sentry/browser';

const LOCAL_STORAGE_MESSAGE_ID = 'breakingNewsClosed';

export const breakingNews = (template: HTMLTemplateElement) => {
  const bodyElement = document.querySelector('body');
  const brandingWrapperElement: HTMLElement | null = document.querySelector('.branding-wrapper');
  // Vytvořit message
  const message = template.content.firstElementChild?.cloneNode(true) as HTMLDivElement;
  const dynamicNavigation: HTMLElement | null = document.querySelector('[data-dynamic-navigation]');

  // Zjistit, zda je v local storage uloženo, že se nemá zobrazovat
  const messageID: string | null = template.getAttribute('data-breaking-news-template');
  const breakingNewsClosed = localStorage.getItem(`${LOCAL_STORAGE_MESSAGE_ID}-${messageID}`);

  // Pokud byla zpráva zavřená, nezobrazovat
  if (breakingNewsClosed) {
    return;
  }

  handlePosition({
    messageID,
    message,
    dynamicNavigation,
    bodyElement,
    brandingWrapperElement,
    navigationElement,
    scrollTop: 0,
  });

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;

    handlePosition({
      messageID,
      message,
      dynamicNavigation,
      bodyElement,
      brandingWrapperElement,
      navigationElement,
      scrollTop,
    });
  });

  // Při kliknutí na 'křížek' zavřít message
  onCloseRemoveMessage({ message });
};

interface HandlePositionProps {
  messageID: string | null;
  message: HTMLDivElement;
  dynamicNavigation: HTMLElement | null;
  bodyElement: HTMLElement | null;
  brandingWrapperElement: HTMLElement | null;
  navigationElement: HTMLElement | null;
  scrollTop: number;
}

export const handlePosition = ({
  messageID = '0',
  message,
  dynamicNavigation,
  bodyElement,
  brandingWrapperElement,
  navigationElement,
  scrollTop,
}: HandlePositionProps) => {
  const breakingNewsClosed = localStorage.getItem(`${LOCAL_STORAGE_MESSAGE_ID}-${messageID}`);

  if (breakingNewsClosed) {
    return;
  }

  addToDOM({
    bodyElement,
    dynamicNavigation,
    brandingWrapperElement,
    message,
  });

  placeUnderNavigation({
    message,
    navigationElement,
    dynamicNavigation,
    scrollTop,
  });
};

interface AddToDOMProps {
  bodyElement: HTMLElement | null;
  dynamicNavigation: HTMLElement | null;
  brandingWrapperElement: HTMLElement | null;
  message: HTMLDivElement;
}
export const addToDOM = ({
  bodyElement,
  dynamicNavigation,
  brandingWrapperElement,
  message,
}: AddToDOMProps) => {
  const breakingNewsCloseID = message.getAttribute('data-breaking-news');
  localStorage.getItem(`${LOCAL_STORAGE_MESSAGE_ID}-${breakingNewsCloseID}`);
  // Přidat do DOMu
  // Na mobilu
  if (isMobile()) {
    // Vložit element na začátek element
    bodyElement?.prepend(message);
  } else {
    // Na desktopu

    // Pokud je dynamická navigace
    if (dynamicNavigation) {
      // Vložit ihned za ní
      dynamicNavigation.after(message);
    } else {
      // Jinak vložit do 'brandingWrapperu'
      if (brandingWrapperElement) {
        brandingWrapperElement.prepend(message);
        brandingWrapperElement.style.paddingTop = '20px';
      }
    }
  }
};

// Umístit pod navigaci / dynamickou navigaci
interface PlaceUnderNavigationProps {
  message: HTMLDivElement;
  navigationElement: HTMLElement | null;
  dynamicNavigation: HTMLElement | null;
  scrollTop: number;
}

export const placeUnderNavigation = ({
  message,
  navigationElement,
  dynamicNavigation,
}: PlaceUnderNavigationProps) => {
  let top = 10;
  if (navigationElement) {
    top = navigationElement.clientHeight + top;
  }

  if (dynamicNavigation && !isMobile()) {
    top = dynamicNavigation.clientHeight + top;
  }

  message.style.top = `${top}px`;
  message.style.marginBottom = '48px';
};

// Zavřít message
interface onCloseRemoveMessageProps {
  message: HTMLDivElement;
}
const onCloseRemoveMessage = ({ message }: onCloseRemoveMessageProps) => {
  const breakingNewsClose = message.querySelector('[data-breaking-news-close]');
  const breakingNewsCloseID = breakingNewsClose?.getAttribute('data-breaking-news-close');
  if (breakingNewsClose) {
    breakingNewsClose.addEventListener('click', () => {
      message.remove();

      // Uložit do local storage UID message, aby se nezobrazovalo znovu
      localStorage.setItem(`${LOCAL_STORAGE_MESSAGE_ID}-${breakingNewsCloseID}`, 'true');
    });
  } else {
    // Sentry
    Sentry.captureMessage('breakingNews: chybí element pro zavření breaking news');
  }
};
